<template>
  <div class="bo6-overlay-page">
    <WZOverlayBO6 :params="params"/>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import WZOverlayBO6 from '../components/WZOverlayBO6.vue';

export default {
  name: 'Bo6OverlayPage',
  components: {
    WZOverlayBO6,
  },

  data() {
    return {
      timer: null,
      params: {
        tracker: '',
        loading: false,
        styles: {
          position: 'vertical', // horizontal | vertical
          labelPosition: 'left', // left | right
          showLabel: true, // true | false
          overlay: {
            color: '#ffca00',
            labelColor: 'red',
            borderWidth: 4,
            borderColor: '#151717',
            size: 80,
            borderRadius: 50,
          },
        },
        data: [
          { items: [] },
        ],
      },
    };
  },

  created() {
    this.init();
    this.timer = setInterval(this.init, 5000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    init() {
      const { uid } = this.$route.params;
      axios.get(`https://api.wzhub.gg/api/camo/${uid}`).then((response) => {
        if (response.data.success) {
          this.params.data.items = response.data.mastery;
          this.params.styles = response.data.camoov.overlay;
          this.params.loading = true;
          this.params.tracker = response.data.camoov.tracker;
        } else {
          clearInterval(this.timer);
          this.params = null;
        }
      });
    },

  },
};
</script>

<style class="scss">

.bo6-overlay-page {
  padding: 10px;
}

</style>
